module.exports = __webpack_public_path__ + "img/female.98ecac75.svg";